import React from "react";
import { Link } from "react-router-dom";
import ScheduleDemo from "./ScheduleDemo";

class Banner extends React.Component{
	render(){
		return (
			<div className="compBanner">
          <div className="compWrapper">
            {/* banner */}
            <section className="col2">
              <div className="bannerDesc">
                  <h1 id="bannerTitle">META Customizations Catalog</h1>
                  <h2>Enhancing the PowerSchool Experience</h2>
                  <p>Learn how our customizations can help you</p>
              </div>
              <div className="bannerbtns">
                <ul>
                  <button className="btn_request_trial"><Link to="/request_trial_form" target="new">Request 30 Day Trial</Link></button>
                  <ScheduleDemo />
                </ul>
              </div>
            </section>
          </div>
          <div className="circles">
            <div className="circle1"></div>
            <div className="circle2"></div>
          </div>
      </div>
		);
	}
}

export default Banner;